import React from 'react';
import { NavLink } from 'react-router-dom';
const Us1_st_types = () => {
  return (
    <div className='fixed top-16 right-0 left-0 h-7 justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-cyan-400 items-center z-50 justify-evenly'>
      
      <NavLink to="/tutoring/learner/us1/us1_st/us1_st_acc" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Accuplacer</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_st/us1_st_acc" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >ACT</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_act" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >ALEKS</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_ale" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >AP</NavLink> 
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_ap" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Bar Exam</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_bar" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >CLT</NavLink>
        
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_clt" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >DAT</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_st/us1_st_dat" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >GED</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_ged" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >GMAT</NavLink>
        <NavLink to="/tutoring/learner/us1_st/us1/us1_st_gma" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >GRE</NavLink> 
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_gre" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >IB</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_ib" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >IELTS</NavLink>
      
      <NavLink to="/tutoring/learner/us1/us1_st/us1_st_iel" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >ITBS</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_st/us1_st_iow" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >LSAT</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_lsa" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >MCAT</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_mca" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >NCLEX</NavLink> 
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_ncl" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >OAT</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_oat" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >PCAT</NavLink>
      
      <NavLink to="/tutoring/learner/us1/us1_st/us1_st_pca" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >PSAT/NMSQT</NavLink>     
      
      <NavLink to="/tutoring/learner/us1/us1_st/us1_st_psa" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >SAT</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_sat" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >SAT10</NavLink>
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_sta" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >TerraNova</NavLink> 
        <NavLink to="/tutoring/learner/us1/us1_st/us1_st_ter" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >TOEFL</NavLink>
      <NavLink to="/tutoring/learner/us1/us1_st/us1_st_usm" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >USMLE</NavLink>
        
    </div>
  );
}

export default Us1_st_types;